import http from "../../http-common";

export default class ImpexiumSubscriptions {
  getPreferenceSubscriptions(userId: string) {
    let url = `/impexium/subscriptions/${userId}`;

    return http.get(url);
  }
}